import React, { FC, ReactNode } from "react"

// Define a type for a component that accepts children
export type ComponentWithChildren = FC<{ children?: ReactNode }>;

// Define the type for the chaining helper function
export type Decorators = (...components: ComponentWithChildren[]) => ComponentWithChildren;

export const buildDecorators: Decorators = (...components) => {
  return ({ children }) => (
    <>
      {components.reduceRight((acc, Component) => (
        <Component>{acc}</Component>
      ), children)}
    </>
  )
}
